var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"focus_toutiao_area"},[_c('img',{attrs:{"width":"150","src":require("@/assets/images/qrcode/ktptoutiao.jpg")}}),_c('span',{staticStyle:{"margin-top":"10px"}},[_vm._v("长按关注课堂派头条，看最新"),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("资讯")])])])
}]

export { render, staticRenderFns }